import { useEffect, useState } from 'react'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import { type CategoryOptions, type CategoryProps, FormKeys, type Values } from '../../SignUpForm.interface'
import styles from './CategoryList.module.scss'

export const CategoryList = ({
  categories,
  name
}: {
  categories: CategoryProps[];
  name: string;
}): JSX.Element => {
  const [options, setOptions] = useState<CategoryOptions[]>([])
  const {
    values,
    setFieldValue
  } = useFormikContext<Values>()

  const key = values[FormKeys.BUSINESS_TYPE]

  useEffect(() => {
    setFieldValue(name, []).then(() => {
      const cats =
        categories.find((x) => x.value === key)?.options ?? []
      setOptions(cats)
    }).catch(console.error)
  }, [key, categories, setFieldValue, name])

  return (
    <>
      <div className={styles['category-tags']}>
        {options
          .sort((a, b) => a.label.localeCompare(b.label))
          .map((x) => (
            <label className={styles['category-tag']} htmlFor={x.id} key={x.id}>
              <Field type="checkbox" name={name} id={x.id} value={x.value} />
              <div className={styles.tag}>{x.label}</div>
            </label>
          ))}

      </div>
      <ErrorMessage
        className={styles['form-input__error-message']}
        component="div"
        name={name}
      />
    </>
  )
}
